import { render } from "./preDeposit.vue?vue&type=template&id=6e064eda&scoped=true"
import script from "./preDeposit.vue?vue&type=script&lang=js"
export * from "./preDeposit.vue?vue&type=script&lang=js"

import "./preDeposit.vue?vue&type=style&index=0&id=6e064eda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e064eda"

export default script